import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { Observable, of, lastValueFrom } from 'rxjs';
import { Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { httpOptions } from "../constants/http-options.constant";

import { environment } from '../../environments/environment';
import { CookieOptions, CookieService } from 'ngx-cookie';

import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: "root"
})

export class AppService {
  private _document = inject(DOCUMENT);
  private _http = inject(HttpClient);
  private _cookieService = inject(CookieService);


  private suiteUrl = this.getServerBaseUrl + '/suite';
  public serviceUrl = this.getServerBaseUrl + '/auth';
  public partyUrl = this.getServerBaseUrl + '/party';
  private serviceGeographyUrl = this.getServerBaseUrl + '/geography';
  private activityUrl = this.getServerBaseUrl + '/activity';
  private notificationUrl = this.getServerBaseUrl + '/notification';


  public authBaseUrl = environment.baseUrlApi + '/auth';

  public locale: string;
  public remove$ = new Subject();
  private headers = new HttpHeaders();

  public get getServerBaseUrl(): string {
    let url = null;
    let cookie = this.getCookie('authType');

    switch (cookie) {
      case 'b2c':
        url = this.getServerADBaseUrl
        break;

      default:
        url = this.getServerASPBaseUrl
        break;
    }

    return url;
  }

  get getServerADBaseUrl(): string {
    let url = null;
    if (this._document.location.host.indexOf("demo.") >= 0)
      url = environment.demoUrlApi;
    else if (this._document.location.host.indexOf("-dev") >= 0)
      url = environment.devUrlADApi;
    else
      url = environment.baseUrlADApi;

    return url
  }

  get getServerASPBaseUrl(): string {
    let url = null;
    if (this._document.location.host.indexOf("demo.") >= 0)
      url = environment.demoUrlApi;
    else if (this._document.location.host.indexOf("-dev") >= 0)
      url = environment.devUrlApi;
    else
      url = environment.baseUrlApi;
    return url
  }


  getGeolocation() {
    return this._http.post('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBP2B5TImI_Y9dHVMexl0_bRTThu1_L3HA', {});
  }

  getElevation(lat: number, lng: number): Observable<any> {
    const url = `https://maps.googleapis.com/maps/api/elevation/json?locations=${lat},${lng}&key=AIzaSyBP2B5TImI_Y9dHVMexl0_bRTThu1_L3HA`;
    return this._http.get(url);
  }

  //#region User Datas

  public getUser(): Observable<any> {
    const url = `${this.serviceUrl}/user`;
    return this._http.get(url, httpOptions);
  }

  public getRealUser(): Observable<any> {
    const url = `${this.serviceUrl}/realuser`;
    return this._http.get(url, httpOptions);
  }

  getUserCompanies(): Observable<any> {
    return this._http.get(this.suiteUrl, httpOptions);
  }

  async getUserPermissions(): Promise<any> {
    try {
      const url = `${this.serviceUrl}/userpermissions?appId=${environment.appId}`;
      return await lastValueFrom(this._http.get(url, httpOptions));
    } catch (error) {
    }
  }

  getAppUserPermissions(idApp: string): Observable<any> {
    let options = { headers: this.headers, withCredentials: true };
    const url = `${this.serviceUrl}/userpermissions?appId=${idApp}`;

    return this._http.get(url, options);
  }

  getUserParty(): Observable<any> {
    const url = this.partyUrl + '/userparty';
    return this._http.get(url, httpOptions)
  }

  getAuthType(username: string) {
    let options = { headers: this.headers, withCredentials: true };
    const url = `${this.authBaseUrl}/getauthtype?username=${username}`;
    return this._http.get(url, options)
  }

  getB2CAuthToken() {
    let serviceUrl = environment.baseUrlADApi + '/auth';
    let options = { headers: this.headers, withCredentials: true };
    const url = `${serviceUrl}/getaccesstoken`;
    return this._http.get(url, options)
  }

  getLanguages(): Observable<any> {
    const url = `${this.getServerBaseUrl}/userprofile/languages`;
    return this._http.get(url, httpOptions)
  }

  getTimezones(): Observable<any> {
    const url = `${this.getServerBaseUrl}/userprofile/timezones`;
    return this._http.get(url, httpOptions)
  }


  getContacts(partyId: String): Observable<any> {
    const url = `${this.getServerBaseUrl}/partycontact?partyId=${partyId}`;
    return this._http.get(url, httpOptions)
  }

  getLocations(partyId: String): Observable<any> {
    const url = `${this.getServerBaseUrl}/partyaddress?partyId=${partyId}`;
    return this._http.get(url, httpOptions)
  }

  getCountries(): Observable<any> {
    const url = `${this.serviceGeographyUrl}/countries`;
    return this._http.get(url, httpOptions)
  }

  //#endregion

  //#region User Operations

  public async setMenuIsOpen(isOpen: Boolean): Promise<any> {
    try {
      const url = `${this.suiteUrl}/setMenuOpen`;
      await lastValueFrom(this._http.put(url, { isOpen }, httpOptions));
      return true;
    } catch (error) {
    }
  }

  public isAuthenticated(): Observable<boolean> {
    return this._http.get<boolean>(this.serviceUrl, httpOptions).pipe(
      catchError(e => of(false))
    );
  }

  signOut(): Observable<any> {
    let options = { headers: this.headers, withCredentials: true };
    const url = this.serviceUrl + '/signout';
    return this._http.get(url, options)
  }

  removeImpersonate(): Observable<any> {
    const url = this.getServerBaseUrl + '/suite/removeimpersonateclaim';
    return this._http.put(url, null, httpOptions);
  }

  impersonateActive(): Observable<any> {
    const url = this.getServerBaseUrl + '/suite/impersonateactive';
    return this._http.get(url, httpOptions)
  }

  saveAccountData(accountData: any): Observable<any> {
    const url = `${this.getServerBaseUrl}/userprofile`;
    return this._http.put(url, accountData, httpOptions)
  }

  //#endregion

  //#region Owner

  setDataOwner(id: string): Promise<any> {
    let params = { dataOwnerId: id }

    const url = `${this.suiteUrl}/setdataowner`;
    return lastValueFrom(this._http.post(url, params, httpOptions))
  }

  getDataOwner(): Promise<any> {
    const url = this.getServerBaseUrl + '/suite/getdataowner';
    return lastValueFrom(this._http.get(url, httpOptions));
  }

  //#endregion

  //#region Alert

  getUserAlerts(): Observable<any> {
    return this._http.get(this.notificationUrl, httpOptions)
  }

  deleteAlert(id: Number): Observable<any> {
    const url = `${this.notificationUrl}?id=${id}`;
    return this._http.delete(url, httpOptions);
  }

  updateAsRead(id: any): Observable<any> {
    const url = `${this.notificationUrl}?id=${id}`;
    return this._http.put(url, httpOptions);
  }

  //#endregion

  //#region Activity

  createActivity(): Observable<any> {
    const url = `${this.activityUrl}/create`;
    return this._http.get(url, httpOptions)
  }

  //#endregion

  //#region Cookie

  /**
* @param {string} key Id to use for lookup.
* @returns {string} Raw cookie value.
*/
  getCookie(key: string) {
    let cookie = this._cookieService.get(key);

    try {
      const decryptedValue = this.decryptValue(cookie);
      return decryptedValue && decryptedValue.trim().length > 0 ? decryptedValue : cookie;

    } catch (e) {
      return cookie;
    }
  }
  //#endregion

  //#region Crypting

  encryptValue(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(environment.cryptingKey);
    const encrypted = CryptoJS.AES.encrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }


  decryptValue(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(environment.cryptingKey);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  //#endregion

  public removeConfirm(text): void {
    this.remove$.next(text);
  }
}
